import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import {
  CustomerVehicle,
  CreateCustomerVehicleRequest,
  UpdateCustomerVehicleRequest,
  ListCustomerVehiclesFilterParams,
  ChangeVehicleOwnershipRequestInterface,
  VehicleEnrichRequest,
} from './CustomerVehicles.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/customers`;

export async function listCustomerVehicles(
  customerId?: number,
  params?: ListCustomerVehiclesFilterParams,
): Promise<PageResult<CustomerVehicle>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/${customerId}/vehicles`,
    params,
  )) as unknown;

  return result as PageResult<CustomerVehicle>;
}

export async function getCustomerVehicle(
  customerId?: number,
  vehicleId?: number,
): Promise<CustomerVehicle> {
  const result = (await api.get(
    `${CONTROLLER_URL}/${customerId}/vehicles/${vehicleId}`,
    null,
  )) as unknown;

  return result as CustomerVehicle;
}

export async function createCustomerVehicle(
  customerId: number,
  obj: CreateCustomerVehicleRequest,
): Promise<CustomerVehicle> {
  const result = (await api.post(
    `${CONTROLLER_URL}/${customerId}/vehicles`,
    obj,
    null,
  )) as unknown;

  return result as CustomerVehicle;
}

export async function updateCustomerVehicle(
  customerId: number,
  vehicleId: number,
  obj: UpdateCustomerVehicleRequest,
): Promise<CustomerVehicle> {
  const result = (await api.put(
    `${CONTROLLER_URL}/${customerId}/vehicles/${vehicleId}`,
    obj,
    null,
  )) as unknown;

  return result as CustomerVehicle;
}

export async function deleteCustomerVehicle(
  customerId: number,
  vehicleId: number,
) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${customerId}/vehicles/${vehicleId}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function changeCustomerVehicleOwnership(
  params: ChangeVehicleOwnershipRequestInterface,
) {
  const response = (await api.put(
    `${API_BASE_URL}/customers/${params.idNewCustomer}/vehicles/change-ownership`,
    params,
    null,
  )) as unknown;
  return response as ChangeVehicleOwnershipRequestInterface;
}

export async function enrichCustomerVehicle(params: VehicleEnrichRequest) {
  const response = (await api.post(
    `${API_BASE_URL}/customers/${params.customerId}/vehicles/${params.vehicleId}/enrich`,
    {},
  )) as unknown;
  return response as void;
}
